import { FC } from "react";

import { REQUIRED_FIELD } from "../../utils/errors";
import styles from "./styles.module.scss";

type Props = {
    error?: string | null;
};

/**
 * Message rouge sous un champ.
 * Les erreurs « champ obligatoire » sont omises : la bordure rouge suffit (+ toast).
 */
const FieldError: FC<Props> = ({ error }) => {
    if (!error || error === REQUIRED_FIELD) return null;
    return <p className={styles.fieldError}>{error}</p>;
};

export default FieldError;
